const info = {
  '4445444000000625001': {
    name: 'Kevin Monsour',
    email: 'kevin.m@cladify.com',
    phone: '416-801-3895'
  },
  '4445444000000623001': {
    name: 'Terri Oswald',
    email: 'terri.o@cladify.com',
    phone: '416-907-4277',
    mobile: '647-674-4228'
  },
  '4445444000000666198': {
    name: 'Alborz Razavi',
    email: 'alborz.r@cladify.com',
    phone: '416-907-4277'
  },
  '4445444000000293001': {
    name: 'Danial Hadizadeh',
    email: 'danial@cladify.com',
    phone: '+1.416.497.7120'
  }
} 

export default info;
